/** 
 * @type {import("./defs").StoreUser} 
 */
const store = {
}
/** 
* @returns {import("./defs").StoreUser} 
*/
export default function () {
    return JSON.parse(JSON.stringify(store));
}


// WEBPACK FOOTER //
// ./resources/js/storers/StoreUser.js